module.exports = __webpack_public_path__ + "static/img/irole.fd5fb85.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/tysdags/irole.png
// module id = voL4
// module chunks = 7